import { Layout, ModuleSystem } from "components"
export const Module = () => {
 return (
  <Layout>
   <ModuleSystem />
  </Layout>
 )
}
